<div [class]="! fromRoute ? 't-popup popup-graphs' : ''" style='display: block;height:100%'>

    <div [class]="! fromRoute ? 'popup-close' : ''" (click)="closed.next(undefined)"></div>
    <div [class]="! fromRoute ? 'popup-frame' : ''">
      
        <div class="popup-body" *ngIf="pathologies && pathologies.length > 0" style="direction: rtl;">
          <button type="button" class="btn btn-primary clickable" style="margin: 10px 0; float: left;" (click)="printPopupBody()">
            <img src="../../../assets/icons/print-blue.svg" alt="Print">
          </button>
          <button (click)="closed.next(undefined)" class="clickable" >
            <mat-icon> close </mat-icon>
          </button>
          <div style="display: flex; font-size: 13pt;">
            <h2>טופס ריכוז דגימות ביופסיה/תעודת משלוח מס. {{inventoryId}}
            <br>
            מעבדה: {{getLabName()}}
            <br>
            תאריך: {{currentDate | date:'dd/MM/yyyy'}}
          </h2>
          <img src="/api/logo" style="max-height: 10em; max-width: 15em;margin-right: 1em;" (error)="$event.target.style.display='none'"/>
          </div>
          
          <table class="pretty-table" style="direction: rtl;">
            <tr >
                <td>#</td>
                <td >מטופל</td>
                <td>Barcode(s)</td>
                <td>מס. דגימות גסטרו</td>
                <td>מס. דגימות קולונו</td>
                <td>חתימת אח/ות</td>
                <td *ngIf="hasFirstNurseSigned() || anySecondNurseHasSigned()">חתימת אח/ות נוסף/ת</td>
                <td>חתימת מזכירה</td>
                <td *ngIf="anySamplesCanBeRemoved()"></td>
            </tr>

            <tr *ngFor="let group of groupedPathologies; index as i">
              <td>{{i+1}}</td>
              <td>
                ת.ז.: {{ getDisplayId(group.pathologies[0].ID) }} <br>
                שם: {{ (group.pathologies[0].First || '') + ' ' + (group.pathologies[0].Last || '') }} <br>
                גורם מימון: {{group.pathologies[0].HMO }} <br>          
                <br>
                מס' מבחנות: {{group.pathologies.length}}
              </td>
              <td>
                <ng-container *ngFor="let path of group.pathologies">
                  <app-barcode [value]="path.BarCode" style="max-width: 20vw;"></app-barcode>
                  <br>
                </ng-container>
              </td>
              <td>{{group.pathologies[0].ExamType == 'Gastroscopy'? group.pathologies.length : ''}}</td>
              <td>{{group.pathologies[0].ExamType == 'Colonoscopy'? group.pathologies.length : ''}}</td>
              <td>
                {{group.pathologies[0].NurseSignature? group.pathologies[0].NurseSignature : ''}}
                <button class="blue-btn" style="font-weight: 500; height: fit-content;" *ngIf="!group.pathologies[0].NurseSignature && loginService.userType === 'nurse'" (click)="signDetails(group.pathologies)">Sign that details are correct</button>
              </td>
              <td *ngIf="hasFirstNurseSigned() || anySecondNurseHasSigned()">
                {{group.pathologies[0].NurseSignature2? group.pathologies[0].NurseSignature2 : ''}}
                <button  class="blue-btn" style="font-weight: 500; height: fit-content;" 
                  *ngIf="group.pathologies[0].NurseSignature && !group.pathologies[0].NurseSignature2 && loginService.userType === 'nurse' && group.pathologies[0].SigningNurse !== loginService.UID"
                  (click)="signDetails(group.pathologies)">Sign that details are correct</button>
              </td>
              <td>
                {{group.pathologies[0].SecretarySignature? group.pathologies[0].SecretarySignature : ''}}
                <button class="blue-btn" style="font-weight: 500; height: fit-content;"  *ngIf="!group.pathologies[0].SecretarySignature && loginService.userType === 'secretary'" (click)="signDetails(group.pathologies)">Sign that details are correct</button>
              </td>
              <td *ngIf="!group.pathologies[0].SecretarySignature && (!group.pathologies[0].NurseSignature)">
                <button class="orange-btn" style="font-weight: 500; height: fit-content;"
                  *ngIf="loginService.userType === 'nurse'"
                  (click)="removeSamplesFromInventory(group.pathologies)">
                  Remove Samples from Inventory
                </button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>סה"כ</td>
              <td></td>
              <td>{{gastroct}}</td>
              <td>{{colonoct}}</td>
              <td></td>
              <td></td>
            </tr>
          </table>
          
          <hr *ngIf="nurseSigningDate || anyNurseHasSigned()" style="border: none; height: 1px; background: linear-gradient(to right, transparent, #ccc 20%, #ccc 80%, transparent); margin: 2em 0 1em 0;">
          
          <p style="display: flex; align-items: center; margin-top: 2em;" *ngIf="nurseSigningDate || anyNurseHasSigned()">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים &nbsp;
            <span *ngIf="nurseSigningDate">
              נחתם על ידי אח/ות: {{groupedPathologies[0].pathologies[0].NurseSignature}} בתאריך: {{this.nurseSigningDate | date:'dd/MM/yyyy'}}
            </span>
            <span *ngIf="!nurseSigningDate && anyNurseHasSigned()">
              נחתם על ידי אח/ות: {{groupedPathologies[0].pathologies[0].NurseSignature}}
            </span>
            <br>
            <button class="orange-btn" *ngIf="!messengerSignedDate && currentUserHasSignedAsNurse()" (click)="removeMySignature('nurse')">
              Drop My Signature
            </button>
          </p>

          <hr *ngIf="anySecondNurseHasSigned()" style="border: none; height: 1px; background: linear-gradient(to right, transparent, #ccc 20%, #ccc 80%, transparent); margin: 2em 0 1em 0;">

          <p style="display: flex; align-items: center; margin-top: 2em;" *ngIf="anySecondNurseHasSigned()">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים &nbsp;
            נחתם על ידי אח/ות נוסף/ת: {{groupedPathologies[0].pathologies[0].NurseSignature2}}
            <br>
            <button class="orange-btn" *ngIf="!messengerSignedDate && currentUserHasSignedAsSecondNurse()" (click)="removeMySignature('nurse2')">
              Drop My Signature
            </button>
          </p>

          <hr *ngIf="secretarySigningDate || anySecretaryHasSigned()" style="border: none; height: 1px; background: linear-gradient(to right, transparent, #ccc 20%, #ccc 80%, transparent); margin: 2em 0 1em 0;">

          <p style="display: flex; align-items: center; margin-top: 2em;" *ngIf="secretarySigningDate || anySecretaryHasSigned()">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים &nbsp;
            <span *ngIf="secretarySigningDate">
              נחתם על ידי מזכירה: {{groupedPathologies[0].pathologies[0].SecretarySignature}} בתאריך: {{this.secretarySigningDate | date:'dd/MM/yyyy'}}
            </span>
            <span *ngIf="!secretarySigningDate && anySecretaryHasSigned()">
              נחתם על ידי מזכירה: {{groupedPathologies[0].pathologies[0].SecretarySignature}}
            </span>
            <br>
            <button class="orange-btn" *ngIf="!messengerSignedDate && currentUserHasSignedAsSecretary()" (click)="removeMySignature('secretary')">
              Drop My Signature
            </button>
            
          <button  class="blue-btn"  *ngIf="! signed && loginService.userType == 'nurse' && nurseSigned()" (click)="signInventory()" style="background: #dcb16b; color: white">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים &nbsp;
            שלח דוח למזכירה
          </button>

          <button class="blue-btn"  *ngIf="! signed && loginService.userType == 'secretary' && secretarySigned() && ! secretarySigningDate" (click)="signInventory()" style="background: #dcb16b; color: white">
            בדקתי את פרטי המשלוח ומצאתי אותם תקינים &nbsp;
          </button>
           

          <hr *ngIf="loginService.userType == 'secretary' && (secretarySigningDate || anySecretaryHasSigned())" style="border: none; height: 1px; background: linear-gradient(to right, transparent, #ccc 20%, #ccc 80%, transparent); margin: 2em 0 1em 0;">

          <!-- Messenger signature pane -->
          <div *ngIf="loginService.userType == 'secretary' && (secretarySigningDate || anySecretaryHasSigned())" style="margin-top:2em;">
            <label for="messenger-signature">חתימת שליח מעבדה:</label>
            <div style="border:1px solid #ccc; width:350px; height:120px; background:#fff; position:relative;">
              <canvas #signaturePad width="350" height="120" style="touch-action: none; width:100%; height:100%;"></canvas>
              <button type="button" style="position:absolute;top:2px;right:2px;" (click)="clearMessengerSignature()">נקה</button>
            </div>
            <input type="text" [(ngModel)]="messengerName" placeholder="הקלד שם שליח" style="margin-top:10px; width:350px;" />
            <br>
            <button (click)="messengerSign()" style="background: #dcb16b; margin-top:10px; width:350px; color: white"
              [disabled]="!messengerName || !messengerSignature" *ngIf="! signing">
               הריני לאשר שבדקתי ומצאתי את פרטי המשלוח נכונים ומתאימים.
            </button>
          </div>
          <div *ngIf="messengerSignedDate" style="margin-top:2em;">
            <p>חתימת השליח :</p>
            <p>תאריך: {{this.messengerSignedDate | date:'dd/MM/yyyy'}}</p>
            <p>שם: {{messengerName}}</p>
            <p>חתימה:</p>
            <img src="/api/lab/messengerSignature/{{inventoryId}}" alt="Messenger Signature" style="max-width: 100%; height: auto;" />
          </div>

  </div>
</div>